import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';

import { MealPlanDefinitionState, useGetMealPlanDefinitionsQuery } from 'data/__generated__';

import { mealPlanDefinitionsColumns, type MealPlanDefinitionRow } from '../constants/mealPlanDefinitionsColumns';

/**
 * Sans `states`, l'API sert les formules ACTIVES depuis son cache — c'est le contrat de totmobile.
 * Le back-office demande explicitement les deux états pour pouvoir filtrer sur les archivées.
 */
const ALL_STATES = [MealPlanDefinitionState.Regular, MealPlanDefinitionState.Archived];

export const MealPlanDefinitionsList = () => {
    const { loading, data, error } = useGetMealPlanDefinitionsQuery({ variables: { states: ALL_STATES } });

    if (loading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!data || error) {
        throw new Error('Une erreur est survenue lors de la récupération des formules');
    }

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<MealPlanDefinitionRow>
                columns={mealPlanDefinitionsColumns}
                data={data.mealPlanDefinitions}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/meal-plan-definition/${row._id}`}
                searchPlaceholder="Nom de la formule"
                searchFilterKey="searchValue"
            />
        </div>
    );
};
